import { Separator } from '@/components/ui/separator'
import type { CartItem } from '../types'

function formatPrice(cents: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100)
}

interface OrderSummaryProps {
  items: CartItem[]
}

export function OrderSummary({ items }: OrderSummaryProps) {
  const subtotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0)

  return (
    <div className="rounded-lg border bg-muted/30 p-4 space-y-3">
      <h3 className="font-semibold text-sm">Order Summary</h3>
      <div className="space-y-2">
        {items.map((item) => (
          <div key={`${item.productId}-${item.variantId}`} className="flex gap-3">
            <div className="h-12 w-12 shrink-0 overflow-hidden rounded bg-muted">
              {item.imageUrl && (
                <img src={item.imageUrl} alt={item.productTitle} className="h-full w-full object-cover" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium leading-tight truncate">{item.productTitle}</p>
              <p className="text-xs text-muted-foreground">{item.variantTitle} × {item.quantity}</p>
            </div>
            <p className="text-sm font-medium shrink-0">{formatPrice(item.price * item.quantity)}</p>
          </div>
        ))}
      </div>
      <Separator />
      <div className="flex justify-between text-sm font-semibold">
        <span>Subtotal</span>
        <span>{formatPrice(subtotal)}</span>
      </div>
      <p className="text-xs text-muted-foreground">
        Shipping costs and taxes will be calculated by Printify during fulfillment.
      </p>
    </div>
  )
}
